import {
  DESCRIPTION_INPUT_CLASS,
  FieldLabel,
  FormSection,
} from "../../../../../components/propertyDescription/descriptionUi";

type Props = {
  condominium: string;
  error?: string;
  onChange: (value: string) => void;
};

export default function CondominiumSection({
  condominium,
  error,
  onChange,
}: Props) {
  return (
    <FormSection title="Condomínio">
      <FieldLabel error={error}>Nome do condomínio</FieldLabel>
      <input
        type="text"
        value={condominium}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Opcional"
        className={DESCRIPTION_INPUT_CLASS}
      />
    </FormSection>
  );
}
